export const planDetailsStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  userPlanInfo: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '18px',
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
    lineHeight: '28px',
    color: '#23252F',
  },
  activeProjectContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  itemTitle: {
    width: '100%',
    marginBottom: '8px',
    fontSize: '14px',
    lineHeight: '146%',
    fontWeight: 400,
    color: '#23252F',
    fontFamily: 'Inter, sans-serif !important',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  switchContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: '8px',
    gap: '8px',
  },
  itemLabel: {
    fontSize: '14px',
    lineHeight: '146%',
    fontWeight: 400,
    color: '#23252F',
    fontFamily: 'Inter, sans-serif !important',
  },
};
